import { useEffect, useRef, useState } from 'react'
import styles from './PopupCTA.module.scss'

const Popup: React.FunctionComponent = () => {
  const popupRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (isClosed || !popupRef.current) return

      const halfWindow = window.scrollY + window.innerHeight * 0.5
      const documentHeight = document.body.offsetHeight * 0.15
      const footer = document.getElementById('contact')
      const footerTop = footer?.getBoundingClientRect().top || Infinity

      if (halfWindow > documentHeight && window.scrollY + window.innerHeight < footerTop + window.scrollY) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isClosed])

  const handleClose = () => {
    setIsVisible(false)
    setIsClosed(true)
  }

  return (
    <div className={`${styles.popupCTA} ${isVisible ? styles.isShow : ''}`} ref={popupRef}>
      <span className={styles.popupCTA__close} onClick={handleClose} />
      <a href="/download/flamingo" className={styles.popupCTA__container} target="_blank" rel="noopener">
        <div className={styles.popupCTA__inner}>
          <figure className={styles.popupCTA__heading}>
            <img src="/img/LP/flamingo/logo_flamingo.svg" alt="flamingo" width={166} height={36} />
          </figure>
          <figure className={styles.popupCTA__image}>
            <img
              src="/img/LP/flamingo/thumbnail_cta_flamingo.webp"
              alt="資料ダウンロード"
              width={262}
              height={164}
              className={styles.popupCTA__image__thum}
            />
          </figure>
        </div>
        <div className={styles.popupCTA__button}>資料ダウンロードはこちら</div>
      </a>
    </div>
  )
}

export default Popup
